// src/components/OrderEdit.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosBackend from "../../api/axiosBackend";

// shadcn
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "components/ui/card";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Textarea } from "components/ui/textarea";
import { Label } from "components/ui/label";

const OrderEdit = ({ onEditSuccess }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  // Fetch the order by ID
  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axiosBackend.get(`/orders/get/${id}`);
        if (response.data.order) {
          setOrder(response.data.order);
        } else {
          setError("Order not found");
        }
      } catch (err) {
        console.error(err);
        setError("Error fetching order details");
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOrder((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    if (!order?.name?.trim()) return "שם חובה";
    if (!order?.phone?.trim()) return "מספר פלאפון חובה";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (v) {
      alert(v); // minimal change; keep your alert flow
      return;
    }
    setSubmitting(true);
    try {
      await axiosBackend.put(`/orders/modify/${id}`, order);
      alert("Order updated successfully");
      if (onEditSuccess) onEditSuccess();
      navigate("/orders");
    } catch (err) {
      console.error(err);
      alert("Error updating order");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background px-4 py-6" dir="rtl">
        <div className="container mx-auto max-w-xl">
          <Card>
            <CardHeader>
              <CardTitle className="text-lg">טוען הזמנה…</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">אנא המתן.</CardContent>
          </Card>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background px-4 py-6" dir="rtl">
        <div className="container mx-auto max-w-xl">
          <Card>
            <CardHeader>
              <CardTitle className="text-lg text-destructive">שגיאה</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">{error}</CardContent>
            <CardFooter className="justify-end">
              <Button variant="secondary" onClick={() => navigate(-1)}>חזרה</Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background px-4 py-6" dir="rtl">
      <div className="container mx-auto max-w-xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl font-bold">עריכת הזמנה</CardTitle>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1">
                <Label htmlFor="name">שם</Label>
                <Input
                  id="name"
                  name="name"
                  value={order?.name || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="phone">מספר פלאפון</Label>
                <Input
                  id="phone"
                  name="phone"
                  value={order?.phone || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="product">מוצר</Label>
                <Input
                  id="product"
                  name="product"
                  value={order?.product || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="space-y-1">
                <Label htmlFor="comments">הערות</Label>
                <Textarea
                  id="comments"
                  name="comments"
                  value={order?.comments || ""}
                  onChange={handleInputChange}
                />
              </div>

              {/* TODO: optional tag editor (re-using your AutocompleteTagInput) */}
              {/* <AutocompleteTagInput selectedTags={...} setSelectedTags={...} /> */}
              {/* map to order.tags ids before submit if needed */}

              <CardFooter className="flex justify-end gap-2 px-0">
                <Button type="button" variant="ghost" onClick={() => navigate(-1)} disabled={submitting}>
                  ביטול
                </Button>
                <Button type="submit" disabled={submitting}>
                  {submitting ? "שומר…" : "עדכן הזמנה"}
                </Button>
              </CardFooter>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OrderEdit;
